import { Module } from '../Module';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';

/*
 * Determines which schedule-related actions a user has permission to perform.
 */
export class SchedulePermissions {
  constructor() {
  }

  // This covers edit, rename, delete, enable/disable
  public canEditSchedule() {
    return getSessionManagementServiceInstance().isSessionServerAdmin();
  }

  public canRunSchedule() {
    return getSessionManagementServiceInstance().isSessionSiteOrServerAdmin();
  }

}

Module.instance().service('SchedulePermissions', SchedulePermissions);
